const analyticsConstants = {
  FETCH_LEARNERS: 'FETCH_LEARNERS',
};

export default analyticsConstants;
